import { Link } from 'react-router-dom'
import styles from './StartPage.module.css'
import { analytics } from '../../../lib/analytics'
import type { MouseEvent } from 'react'

const options = [
  { to: '/', title: 'Начать диалог', text: 'Поговорить о том, что происходит сейчас.', icon: 'icon-chat.svg' },
  { to: '/progress', title: 'Посмотреть свой путь', text: 'Где вы сейчас, что впереди и небольшой шаг на сегодня.', icon: 'icon-journey.svg' },
  { to: '/sos', title: 'Запустить SOS — практику', text: 'Дыхательное упражнение, когда очень тяжело.', icon: 'icon-sos.svg' },
]

export default function StartPage() {
  const trackChoice = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.currentTarget.getAttribute('href') === '/sos') analytics.track('sosClicked')
  }
  return <section className={styles.page} aria-labelledby="start-title">
    <h1 id="start-title">С чего начать?</h1>
    <p className={styles.subtitle}>Выберите, что сделать сначала. Всё остальное останется под рукой.</p>
    <ol className={styles.list}>
      {options.map((option, index) => <li key={option.to}>
        <Link to={option.to} className={styles.card} onClick={trackChoice}>
          <span className={styles.icon} aria-hidden="true"><span style={{ maskImage: `url(/assets/${option.icon})` }} /></span>
          <span className={styles.body}>
            <span className={styles.title}>{index + 1}. {option.title}</span>
            <span className={styles.text}>{option.text}</span>
          </span>
          <span className={styles.arrow} aria-hidden="true">↗</span>
        </Link>
      </li>)}
    </ol>
  </section>
}
